import {
  useWhatIfPositions,
  whatIfEditMode,
} from "@iliotech/data-wire/src/stores";
import { WhatIfPositionsTableCellProps } from "../WhatIfPositionsTable";
import { observer } from "mobx-react-lite";
import {
  NumericTextBox,
  NumericTextBoxChangeEvent,
} from "@progress/kendo-react-inputs";
import classNames from "classnames";
import s from "./Cells.module.scss";
import { MdLock, MdLockOpen } from "react-icons/md";

const PortfolioPercentageCell = ({ index }: WhatIfPositionsTableCellProps) => {
  const store = useWhatIfPositions();

  const portfolioPercentage = store.getField<number>(
    "portfolioPercentage",
    index
  );
  const disabled = !portfolioPercentage;
  const onChange = (event: NumericTextBoxChangeEvent) => {
    store.onRowPercentageChange(index, event?.value || 0);
  };
  const editMode = store.editMode;
  const fixed = store.getField<boolean>("fixed", index);
  const updateFixed = () => {
    store.onToggleFixed(index);
  };
  if (editMode === whatIfEditMode.PERCENTAGE) {
    return (
      <div className={s.quantityWrapper}>
        <NumericTextBox
          placeholder="Enter percentage"
          name={"portfolioPercentage"}
          value={portfolioPercentage || 0}
          format={{
            maximumFractionDigits: 7,
          }}
          //@ts-ignore
          format="n2"
          className={classNames(disabled && s.disabled)}
          spinners={false}
          onChange={onChange}
        />
        <div onClick={updateFixed} className={s.lockIconWrapper}>
          {!!fixed ? (
            <MdLock className={s.lockIcon} />
          ) : (
            <MdLockOpen className={s.lockIcon} />
          )}
        </div>
      </div>
    );
  }
  const formattedValue = portfolioPercentage
    ? portfolioPercentage.toFixed(1)
    : "";

  return <span>{formattedValue || 0}</span>;
};

export default observer(PortfolioPercentageCell);
